export default "__VITE_ASSET__tZ95WVOr__"